import { memo } from 'react';

import { IconButton } from '@components/icon-button';
import { IconReplace } from '@components/icons/replace';
import { getScopedTranslate, useScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { ActionRemoveButton, nodeToActionBasic } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard, NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { useReplaceSidebar } from './replace-sidebar';

type ActionType = 'placeholder';

export const getDescription = (action: JourneyAction<ActionType>) => {
  const { t } = getScopedTranslate(nodeLocale);
  return action.description ?? t('noDescription');
};

export const Node = memo((node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  const showReplaceSidebar = useReplaceSidebar();

  const handleReplace = () => {
    showReplaceSidebar({
      shortId: node.id,
      isEdit: false,
    });
  };

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={t('title')}>
        <ActionRemoveButton action={nodeToActionBasic(node)} />
        <IconButton
          icon={<IconReplace />}
          variant="ghost-purple"
          stopPropagation
          onClick={handleReplace}
        />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Placeholder',
    noDescription: 'No description',
  },
};
